// Application types

const FOOD = {
  LOADING_FOOD: "LOADING_FOOD",
  ALL_FOODS: "ALL_FOODS",
  SINGLE_FOOD: "SINGLE_FOOD",
};

export default FOOD;
